module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('ul', [_vm._l((_vm.bottomLinks), function(item, index) {
    return _c('li', {
      key: 'link_' + index
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toDetail(item.id)
        }
      }
    }, [_vm._v("\n                               " + _vm._s(item.title) + "\n                           ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toDetail(-1)
      }
    }
  }, [_vm._v("\n                               用户反馈\n                           ")])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('div', {
    staticClass: "companyAddress"
  }, [_vm._v("\n                 福建省军缘科技有限公司 地址：福建省泉州市鲤城区开元街道顶埔108号D栋四楼 电话：0595—22192781\n               ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.filingsType == 1) ? _c('p', [_vm._v("Copyright ©2023 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("军缘-闽ICP备2023013448号-1")])]) : _vm._e(), _vm._v(" "), (_vm.filingsType == 4) ? _c('p', [_vm._v("Copyright ©2023 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("军缘-闽ICP备2023013448号-4")])]) : _vm._e(), _vm._v(" "), (_vm.filingsType == 5) ? _c('p', [_vm._v("Copyright ©2023 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("军缘-闽ICP备2023013448号-5")])]) : _vm._e(), _vm._v(" "), (_vm.filingsType == 6) ? _c('p', [_vm._v("Copyright ©2023 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("军缘-闽ICP备2023013448号-6")])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "icon icon-footer-1"
  }), _vm._v(" "), _c('span', [_vm._v("正品行货，品质保证")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon icon-footer-2"
  }), _vm._v(" "), _c('span', [_vm._v("品类齐全，轻松购物")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon icon-footer-3"
  }), _vm._v(" "), _c('span', [_vm._v("满99元免邮费")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon icon-footer-4"
  }), _vm._v(" "), _c('span', [_vm._v("7天无忧退换货")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad92a87e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footers/index.vue
// module id = 780
// module chunks = 2